import { ActiviteitClass } from '@/domain/interface/activiteit/ActiviteitClass';
import { MeldingRequestDto } from '@/domain/interface/melding/MeldingRequestDto';

export class ActiviteitRequestDto extends MeldingRequestDto {
  activiteitType?: string;
  datumActiviteit?: Date;
  verwarmingType?: string;

  constructor(activiteit: ActiviteitClass) {
    super(activiteit);
    this.activiteitType = activiteit.activiteitType?.omschrijving;
    this.datumActiviteit = activiteit.datumActiviteit;
    this.verwarmingType = activiteit.verwarmingType?.omschrijving;
  }
}
